export default {
  name: 'create',
  components: {},
  props: [],
  data () {
    return {
      errors: {},
      data: {},
      btn_submit: false,
      loading: '',
      normalizer_ctg (node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        }
      },
    }
  },
  computed: {
    category () {
      return this.$store.getters['CategoryChk/getListRecursive']
    },
  },
  mounted () {
    this.loading = true
  
    Promise.all([
      this.category.length ==0 ?this.$store.dispatch('CategoryChk/getListCtg'):'',
    ]).then(res => {
      this.loading = false
      
    }).catch(errors => {
      this.loading = false
      
    })
  },
  methods: {
    showCreateForm () {
      this.$refs.createForm.show()
    },
    create(){
      this.btn_submit = true
    
      this.data.default = 'false'
      this.$store.dispatch('CategoryChk/create', {ctg: this.data}).then(res => {
        
        this.data = {}
        this.errors ={}
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.create_success')
        })
        this.$refs.createForm.hide()
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        
        this.btn_submit = false
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/category-checklist/create/create.js